<div class="confirmation-container">
  <div class="confirmation-card">
    <h2 class="confirmation-title">Confirmar Registro</h2>
    
    @if (errorMessage) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
    }
    
    @if (successMessage) {
      <div class="success-message">
        {{ successMessage }}
      </div>
    }

    <p class="confirmation-description">
      Ingresa el código de verificación enviado a <strong>{{ email }}</strong>
    </p>

    <form class="confirmation-form" (ngSubmit)="confirmSignup()">
      <div class="form-group">
        <label for="code" class="form-label">Código de Verificación</label>
        <input 
          type="text" 
          id="code" 
          name="code" 
          required 
          class="form-input"
          [(ngModel)]="verificationCode"
          [disabled]="isLoading"
          placeholder="Ej: 123456"
        >
      </div>

      <button type="submit" class="submit-button" [disabled]="isLoading">
        @if (!isLoading) {
          <span>Confirmar Registro</span>
        }
        @if (isLoading) {
          <span>Confirmando...</span>
        }
      </button>
    </form>

    <div class="resend-container">
      <p>¿No recibiste el código?</p>
      <button 
        type="button" 
        class="resend-button" 
        (click)="resendCode()"
        [disabled]="isLoading"
      >
        Reenviar código
      </button>
    </div>
  </div>
</div>